import { Component } from '@angular/core';

@Component({
  selector: 't-confirmation-viewer-icon',
  standalone: true,
  imports: [],
  templateUrl: './confirmation-viewer-icon.component.html',
  styleUrl: './confirmation-viewer-icon.component.css',
})
export class ConfirmationViewerIconComponent {}
